import { useNavigate } from 'react-router-dom';
import { TestId } from '@repo/test-id';
import { tr } from '@repo/locale';
import { Button } from '@repo/ui';

import { logout } from '@features/auth/services/authService';
import { useAuthStore } from '@features/auth/stores/useAuthStore';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export default function ImpersonationBanner() {
  const navigate = useNavigate();
  const isImpersonating = useAuthStore((state) => state.isImpersonating);

  const testId = TestId.root('impersonationBanner');

  const handleStop = () => {
    logout();
    navigate(ROUTE_PATHS[RouteName.MAP]);
  };

  if (!isImpersonating) return null;

  return (
    <div
      role="alert"
      data-testid={testId}
      className="z-impersonation bg-fg-danger-strong border-danger fixed inset-x-0 top-0 mx-auto mt-4 flex max-w-100 items-center justify-center gap-4 rounded-xl border-2 px-4 py-2 text-white"
    >
      <span className="font-semibold text-white">{tr('auth:impersonation.banner.message')}</span>
      <Button
        testId={testId.append('stopButton')}
        label={tr('auth:impersonation.banner.stop')}
        color="brand"
        size="xs"
        onClick={handleStop}
      />
    </div>
  );
}
